export default {"src":"/_next/static/media/gear.56f5fcd3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};